import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putTenantFeatureFlag = (token, id, TenantID, FeatureFlagID, InContract = true) => {
    return fetch(`${apiUrl}tenant_feature_flags/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            TenantID,
            FeatureFlagID,
            InContract
        })
    });
}

export default putTenantFeatureFlag